import { fetchBusinessLocation } from "../../redux/slices/businessLocationSlice";
import { fetchClientPackages } from "../../redux/slices/clientPackagesSlice";
import { fetchProducts } from "../../redux/slices/inventorySlice";
import { fetchMaster } from "../../redux/slices/masterSlice";
import { fetchMasterPhoto } from "../../redux/slices/profileImageSlice";
import { fetchPushToken } from "../../redux/slices/pushTokensSlice";
import { fetchServicePackageById, fetchServicePackages } from "../../redux/slices/servicePackagesSlice";
import { fetchSpecialities } from "../../redux/slices/specialitiesSlice";
import { fetchTakbullStatus } from "../../redux/slices/takbullConnect";
import { fetchTakbullPaymentStatus } from "../../redux/slices/takbullPaymentGatewaySlice";
import { fetchUserByUid } from "../../redux/slices/userSlice";

export const loadMasterProfileData = async (masterId, dispatch) => {
    const promises = [
        dispatch(fetchUserByUid()),
        dispatch(fetchMaster(masterId)),
        dispatch(fetchSpecialities(masterId)),
        dispatch(fetchMasterPhoto(masterId)),
        dispatch(fetchPushToken(masterId)),
        dispatch(fetchBusinessLocation(masterId)),
        dispatch(fetchProducts(masterId)),
        dispatch(fetchTakbullStatus(masterId)),
        dispatch(fetchTakbullPaymentStatus(masterId)),
        dispatch(fetchClientPackages(masterId)),
        dispatch(fetchServicePackages(masterId)),
        dispatch(fetchServicePackageById(masterId)),

    ];

    await Promise.all(promises);
};
